<template>
  <hot-table ref="table" :settings="settings" :data="localeData"></hot-table>
</template>

<script>
  import { HotTable } from '@handsontable/vue';

  export default {
    components: {
      HotTable
    },
    props: {
      schema: Object
    },
    name: 'LocaleEditor',
    data () {
      return {
        settings: {
          fixedColumnsLeft: 1,
          width: '100%',
          maxWidth: '100%',
          stretchH: 'all',
          colWidths: '33%',
          height: 600,
          // height: '100%',
          colHeaders: [
            this.$gettext('Source string'),
            this.$gettext('Russian version'),
            this.$gettext('English version')
          ],
          columns: [
            {
              data: 'source',
              readOnly: true
            },
            {
              data: 'ru'
            },
            {
              data: 'en'
            }
          ],
          rowHeaders: true,
          manualColumnMove: true,
          manualColumnResize: true,
          autoColumnSize: true,
          licenseKey: 'non-commercial-and-evaluation'
        },
        localeData: null,
        uniqueStrings: null
      }
    },
    mounted () {
      this.localeData = []
      this.uniqueStrings = []
      this.$refs.table.hotInstance.addHook('afterChange', this.modifyData)
      // Добавляем заголовок
      this.addField(this.schema.title)
      Object.values(this.schema.properties).map(value => {
        // Добавляем заголовок
        this.addField(value.title)
        const attrs = value.attrs || null
        if (attrs) {
          // Добавляем заголовок
          this.addField(attrs.title)
          // Добавляем плейсхолдер
          this.addField(attrs.title)
        }
        // Добавляем варианты ответов
        const allChoices = [value.anyOf, value.oneOf, value.enum].filter(e => e !== undefined)
        allChoices.map(choices => {
          choices.map(choice => {
            this.addField(choice.label)
          })
        })
      })
    },
    methods: {
      addField (title) {
        if (title) {
          title = title.trim()
          if (title.length > 0 && !this.uniqueStrings.includes(title)) {
            this.localeData.push({
              source: title,
              ru: this.getLocale(title, 'ru', title),
              en: this.getLocale(title, 'en')
            })
            this.uniqueStrings.push(title)
          }
        }
      },
      modifyData (changes) {
        if (changes) {
          console.warn(`Данные изменились`, changes)
          const additionalProperties = this.schema.additionalProperties || {}
          this.schema.additionalProperties = additionalProperties
          const locales = additionalProperties.locales || {}
          additionalProperties.locales = locales
          const ru = {}
          locales.ru = ru
          const en = {}
          locales.en = en
          this.localeData.map(e => {
            // Применяем русскую версию
            if (e.ru && e.ru.trim().length > 0) {
              ru[e.source] = e.ru.trim()
            } else if (ru[e.source] !== undefined) {
              delete ru[e.source]
            }
            // Применяем английскую версию
            if (e.en && e.en.trim().length > 0) {
              en[e.source] = e.en.trim()
            } else if (en[e.source] !== undefined) {
              delete en[e.source]
            }
          })
        }
      },
      getLocale (title, locale, defaultValue=null) {
        if (this.schema.additionalProperties) {
          const additionalProperties = this.schema.additionalProperties || {}
          this.schema.additionalProperties = additionalProperties
          const locales = additionalProperties.locales || {}
          additionalProperties.locales = locales
          const localeDict = locales[locale] || {}
          let value = localeDict[title]
          if (value && value.trim().length > 0) {
            return value
          } else {
            return defaultValue
          }
        } else {
          return defaultValue
        }
      }
    }
  }
</script>

<style scoped>

</style>
